import { render, staticRenderFns } from "./SendNotifyProductCount.vue?vue&type=template&id=652493e2"
import script from "./SendNotifyProductCount.vue?vue&type=script&lang=js"
export * from "./SendNotifyProductCount.vue?vue&type=script&lang=js"
import style0 from "./SendNotifyProductCount.vue?vue&type=style&index=0&id=652493e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports